import { createSlice } from '@reduxjs/toolkit'
import axios from '../../api/index'

const genders = [
  { id: 1, name: 'male' },
  { id: 2, name: 'female' },
  { id: 3, name: 'intersex' },
]

const countries = [
  { id: 1, name: 'iran' },
  { id: 2, name: 'afghanistan' },
]

const knowUsTypes = [
  { id: 1, name: 'tv' },
  { id: 2, name: 'freinds' },
  { id: 3, name: 'classmate' },
  { id: 4, name: 'sms' },
  { id: 5, name: 'radio' },
  { id: 6, name: 'none' },
]

const educations = [
  { id: 1, name: 'great' },
  { id: 2, name: 'degree' },
  { id: 3, name: 'deploma' },
  { id: 4, name: 'associateDegree' },
  { id: 5, name: 'bachelor' },
  { id: 6, name: 'master' },
  { id: 7, name: 'phd' },
]

const registrerType = [
  { id: 1, name: 'parents' },
  { id: 2, name: 'father' },
  { id: 3, name: 'mother' },
  { id: 4, name: 'student' },
]

const timeSpents = [
  { id: 1, name: 'کمتر از یک ساعت' },
  { id: 2, name: 'بین یک تا سه ساعت' },
  { id: 3, name: 'بین سه تا هفت ساعت' },
  { id: 4, name: 'بیشتر از هفت ساعت' },
]

const ageCategories = [
  {
    ageCategoryId: 1,
    name: 'رده سنی الف - 3 تا 7 سال',
    fromYear: 3,
    toYear: 7,
  },
  {
    ageCategoryId: 2,
    name: 'رده سنی ب - 8 تا 9 سال',
    fromYear: 8,
    toYear: 9,
  },
  {
    ageCategoryId: 3,
    name: 'رده سنی ج - 10 تا 12 سال',
    fromYear: 10,
    toYear: 12,
  },
  {
    ageCategoryId: 4,
    name: 'رده سنی د - 13 تا 15 سال',
    fromYear: 13,
    toYear: 15,
  },
  {
    ageCategoryId: 5,
    name: 'رده سنی هـ - 16 تا 18 سال',
    fromYear: 16,
    toYear: 18,
  },
  {
    ageCategoryId: 7,
    name: 'رده سنی آفتاب لب بوم - 19 سال و به بالا',
    fromYear: 19,
    toYear: 120,
  },
]

const proviences = [
  {
    id: 0,
    name: 'مرکزي',
    cities: [
      {
        id: 1,
        name: 'اراک',
      },
      {
        id: 2,
        name: 'آشتيان',
      },
      {
        id: 3,
        name: 'تفرش',
      },
      {
        id: 4,
        name: 'خمين',
      },
      {
        id: 5,
        name: 'دليجان',
      },
      {
        id: 6,
        name: 'ساوه',
      },
      {
        id: 7,
        name: 'شازند',
      },
      {
        id: 9,
        name: 'محلات',
      },
      {
        id: 10,
        name: 'زرنديه',
      },
      {
        id: 11,
        name: 'کميجان',
      },
      {
        id: 12,
        name: 'خنداب',
      },
      {
        id: 13,
        name: 'فراهان',
      },
    ],
  },
  {
    id: 1,
    name: 'گيلان',
    cities: [
      {
        id: 1,
        name: 'آستارا',
      },
      {
        id: 2,
        name: 'آستانه اشرفيه',
      },
      {
        id: 3,
        name: 'بندرانزلي',
      },
      {
        id: 4,
        name: 'طوالش',
      },
      {
        id: 5,
        name: 'رشت',
      },
      {
        id: 6,
        name: 'رودبار',
      },
      {
        id: 7,
        name: 'رودسر',
      },
      {
        id: 8,
        name: 'صومعه سرا',
      },
      {
        id: 9,
        name: 'فومن',
      },
      {
        id: 10,
        name: 'لنگرود',
      },
      {
        id: 11,
        name: 'لاهيجان',
      },
      {
        id: 12,
        name: 'شفت',
      },
      {
        id: 13,
        name: 'املش',
      },
      {
        id: 14,
        name: 'رضوانشهر',
      },
      {
        id: 15,
        name: 'سياهكل',
      },
      {
        id: 16,
        name: 'ماسال',
      },
    ],
  },
  {
    id: 2,
    name: 'مازندران',
    cities: [
      {
        id: 1,
        name: 'آمل',
      },
      {
        id: 2,
        name: 'بابل',
      },
      {
        id: 4,
        name: 'بهشهر',
      },
      {
        id: 5,
        name: 'تنكابن',
      },
      {
        id: 6,
        name: 'رامسر',
      },
      {
        id: 7,
        name: 'سارئ',
      },
      {
        id: 8,
        name: 'سوادكوه',
      },
      {
        id: 10,
        name: 'قائم شهر',
      },
      {
        id: 14,
        name: 'نور',
      },
      {
        id: 15,
        name: 'نوشهر',
      },
      {
        id: 16,
        name: 'بابلسر',
      },
      {
        id: 18,
        name: 'محمودآباد',
      },
      {
        id: 19,
        name: 'نكا',
      },
      {
        id: 20,
        name: 'چالوس',
      },
      {
        id: 21,
        name: 'جويبار',
      },
      {
        id: 22,
        name: 'گلوگاه',
      },
      {
        id: 23,
        name: 'فريدونكنار',
      },
      {
        id: 24,
        name: 'عباس آباد',
      },
      {
        id: 25,
        name: 'مياندورود',
      },
      {
        id: 26,
        name: 'سيمرغ',
      },
      {
        id: 27,
        name: 'سوادکوه شمالي',
      },
      {
        id: 28,
        name: 'کلاردشت',
      },
    ],
  },
  {
    id: 3,
    name: 'آذربايجان شرقي',
    cities: [
      {
        id: 2,
        name: 'اهر',
      },
      {
        id: 3,
        name: 'تبريز',
      },
      {
        id: 5,
        name: 'سراب',
      },
      {
        id: 6,
        name: 'مراغه',
      },
      {
        id: 7,
        name: 'مرند',
      },
      {
        id: 10,
        name: 'ميانه',
      },
      {
        id: 11,
        name: 'هشترود',
      },
      {
        id: 12,
        name: 'بناب',
      },
      {
        id: 13,
        name: 'بستان آباد',
      },
      {
        id: 14,
        name: 'شبستر',
      },
      {
        id: 15,
        name: 'کليبر',
      },
      {
        id: 16,
        name: 'هريس',
      },
      {
        id: 19,
        name: 'جلفا',
      },
      {
        id: 20,
        name: 'ملکان',
      },
      {
        id: 21,
        name: 'آذرشهر',
      },
      {
        id: 22,
        name: 'اسکو',
      },
      {
        id: 23,
        name: 'چاراويماق',
      },
      {
        id: 24,
        name: 'ورزقان',
      },
      {
        id: 25,
        name: 'عجب شير',
      },
      {
        id: 26,
        name: 'خداآفرين',
      },
      {
        id: 27,
        name: 'هوراند',
      },
    ],
  },
  {
    id: 4,
    name: 'آذربايجان غربي',
    cities: [
      {
        id: 1,
        name: 'اروميه',
      },
      {
        id: 2,
        name: 'پيرانشهر',
      },
      {
        id: 3,
        name: 'خوئ',
      },
      {
        id: 4,
        name: 'سردشت',
      },
      {
        id: 5,
        name: 'سلماس',
      },
      {
        id: 6,
        name: 'ماكو',
      },
      {
        id: 7,
        name: 'مهاباد',
      },
      {
        id: 8,
        name: 'مياندوآب',
      },
      {
        id: 9,
        name: 'نقده',
      },
      {
        id: 10,
        name: 'بوكان',
      },
      {
        id: 11,
        name: 'شاهين دژ',
      },
      {
        id: 12,
        name: 'تكاب',
      },
      {
        id: 13,
        name: 'اشنويه',
      },
      {
        id: 14,
        name: 'چالدران',
      },
      {
        id: 15,
        name: 'پلدشت',
      },
      {
        id: 16,
        name: 'چايپاره',
      },
      {
        id: 17,
        name: 'شوط',
      },
    ],
  },
  {
    id: 5,
    name: 'کرمانشاه',
    cities: [
      {
        id: 1,
        name: 'اسلام آبادغرب',
      },
      {
        id: 2,
        name: 'کرمانشاه',
      },
      {
        id: 3,
        name: 'پاوه',
      },
      {
        id: 4,
        name: 'سرپل ذهاب',
      },
      {
        id: 5,
        name: 'سنقر',
      },
      {
        id: 6,
        name: 'قصرشيرين',
      },
      {
        id: 7,
        name: 'کنگاور',
      },
      {
        id: 8,
        name: 'گيلانغرب',
      },
      {
        id: 9,
        name: 'جوانرود',
      },
      {
        id: 10,
        name: 'صحنه',
      },
      {
        id: 11,
        name: 'هرسين',
      },
      {
        id: 12,
        name: 'ثلاث باباجاني',
      },
      {
        id: 13,
        name: 'دالاهو',
      },
      {
        id: 14,
        name: 'روانسر',
      },
    ],
  },
  {
    id: 6,
    name: 'خوزستان',
    cities: [
      {
        id: 1,
        name: 'آبادان',
      },
      {
        id: 2,
        name: 'انديمشک',
      },
      {
        id: 3,
        name: 'اهواز',
      },
      {
        id: 4,
        name: 'ايذه',
      },
      {
        id: 5,
        name: 'بندرماهشهر',
      },
      {
        id: 6,
        name: 'بهبهان',
      },
      {
        id: 7,
        name: 'خرمشهر',
      },
      {
        id: 8,
        name: 'دزفول',
      },
      {
        id: 9,
        name: 'دشت آزادگان',
      },
      {
        id: 10,
        name: 'رامهرمز',
      },
      {
        id: 11,
        name: 'شادگان',
      },
      {
        id: 12,
        name: 'شوشتر',
      },
      {
        id: 13,
        name: 'مسجدسليمان',
      },
      {
        id: 14,
        name: 'شوش',
      },
      {
        id: 15,
        name: 'باغ ملک',
      },
      {
        id: 16,
        name: 'اميديه',
      },
      {
        id: 17,
        name: 'لالي',
      },
      {
        id: 18,
        name: 'هنديجان',
      },
      {
        id: 19,
        name: 'رامشير',
      },
      {
        id: 20,
        name: 'گتوند',
      },
      {
        id: 21,
        name: 'انديکا',
      },
      {
        id: 22,
        name: 'هفتکل',
      },
      {
        id: 23,
        name: 'هويزه',
      },
      {
        id: 24,
        name: 'باوي',
      },
      {
        id: 25,
        name: 'حميديه',
      },
      {
        id: 26,
        name: 'آغاجاري',
      },
      {
        id: 27,
        name: 'کارون',
      },
    ],
  },
  {
    id: 7,
    name: 'فارس',
    cities: [
      {
        id: 1,
        name: 'آباده',
      },
      {
        id: 2,
        name: 'استهبان',
      },
      {
        id: 3,
        name: 'اقليد',
      },
      {
        id: 4,
        name: 'جهرم',
      },
      {
        id: 5,
        name: 'داراب',
      },
      {
        id: 6,
        name: 'سپيدان',
      },
      {
        id: 7,
        name: 'شيراز',
      },
      {
        id: 8,
        name: 'فسا',
      },
      {
        id: 9,
        name: 'فيروزآباد',
      },
      {
        id: 10,
        name: 'کازرون',
      },
      {
        id: 11,
        name: 'لارستان',
      },
      {
        id: 12,
        name: 'مرودشت',
      },
      {
        id: 13,
        name: 'ممسني',
      },
      {
        id: 14,
        name: 'ني ريز',
      },
      {
        id: 15,
        name: 'لامرد',
      },
      {
        id: 16,
        name: 'بوانات',
      },
      {
        id: 17,
        name: 'ارسنجان',
      },
      {
        id: 18,
        name: 'خرم بيد',
      },
      {
        id: 19,
        name: 'زرين دشت',
      },
      {
        id: 20,
        name: 'قيروکارزين',
      },
      {
        id: 21,
        name: 'مهر',
      },
      {
        id: 22,
        name: 'فراشبند',
      },
      {
        id: 23,
        name: 'پاسارگاد',
      },
      {
        id: 24,
        name: 'خنج',
      },
      {
        id: 25,
        name: 'سروستان',
      },
      {
        id: 26,
        name: 'رستم',
      },
      {
        id: 27,
        name: 'گراش',
      },
      {
        id: 28,
        name: 'کوار',
      },
      {
        id: 29,
        name: 'خرامه',
      },
      {
        id: 30,
        name: 'زرقان',
      },
      {
        id: 31,
        name: 'بیضا',
      },
      {
        id: 32,
        name: 'سرچهان',
      },
      {
        id: 33,
        name: 'کوه چنار',
      },
      {
        id: 34,
        name: 'خفر',
      },
      {
        id: 35,
        name: 'بختگان',
      },
      {
        id: 36,
        name: 'اوز',
      },
    ],
  },
  {
    id: 8,
    name: 'كرمان',
    cities: [
      {
        id: 1,
        name: 'بافت',
      },
      {
        id: 2,
        name: 'بم',
      },
      {
        id: 3,
        name: 'جيرفت',
      },
      {
        id: 4,
        name: 'رفسنجان',
      },
      {
        id: 5,
        name: 'زرند',
      },
      {
        id: 6,
        name: 'سيرجان',
      },
      {
        id: 7,
        name: 'شهربابك',
      },
      {
        id: 8,
        name: 'كرمان',
      },
      {
        id: 9,
        name: 'كهنوج',
      },
      {
        id: 10,
        name: 'بردسير',
      },
      {
        id: 11,
        name: 'راور',
      },
      {
        id: 12,
        name: 'عنبرآباد',
      },
      {
        id: 13,
        name: 'منوجان',
      },
      {
        id: 14,
        name: 'كوهبنان',
      },
      {
        id: 15,
        name: 'رودبارجنوب',
      },
      {
        id: 16,
        name: 'قلعه گنج',
      },
      {
        id: 17,
        name: 'ريگان',
      },
      {
        id: 18,
        name: 'رابر',
      },
      {
        id: 19,
        name: 'فهرج',
      },
      {
        id: 20,
        name: 'انار',
      },
      {
        id: 21,
        name: 'نرماشير',
      },
      {
        id: 22,
        name: 'فارياب',
      },
      {
        id: 23,
        name: 'ارزوئيه',
      },
    ],
  },
  {
    id: 9,
    name: 'خراسان رضوئ',
    cities: [
      {
        id: 4,
        name: 'تايباد',
      },
      {
        id: 5,
        name: 'تربت حيدريه',
      },
      {
        id: 6,
        name: 'تربت جام',
      },
      {
        id: 7,
        name: 'درگز',
      },
      {
        id: 8,
        name: 'سبزوار',
      },
      {
        id: 13,
        name: 'قوچان',
      },
      {
        id: 14,
        name: 'كاشمر',
      },
      {
        id: 15,
        name: 'گناباد',
      },
      {
        id: 16,
        name: 'مشهد',
      },
      {
        id: 17,
        name: 'نيشابور',
      },
      {
        id: 18,
        name: 'چناران',
      },
      {
        id: 19,
        name: 'خواف',
      },
      {
        id: 20,
        name: 'سرخس',
      },
      {
        id: 22,
        name: 'فريمان',
      },
      {
        id: 23,
        name: 'بردسكن',
      },
      {
        id: 27,
        name: 'رشتخوار',
      },
      {
        id: 28,
        name: 'كلات',
      },
      {
        id: 29,
        name: 'خليل آباد',
      },
      {
        id: 30,
        name: 'مه ولات',
      },
      {
        id: 31,
        name: 'بجستان',
      },
      {
        id: 32,
        name: 'بينالود',
      },
      {
        id: 33,
        name: 'فيروزه',
      },
      {
        id: 34,
        name: 'جغتاي',
      },
      {
        id: 35,
        name: 'زاوه',
      },
      {
        id: 36,
        name: 'جوين',
      },
      {
        id: 37,
        name: 'باخرز',
      },
      {
        id: 38,
        name: 'خوشاب',
      },
      {
        id: 39,
        name: 'داورزن',
      },
      {
        id: 40,
        name: 'صالح آباد',
      },
      {
        id: 41,
        name: 'کوهسرخ',
      },
    ],
  },
  {
    id: 10,
    name: 'اصفهان',
    cities: [
      {
        id: 1,
        name: 'اردستان',
      },
      {
        id: 2,
        name: 'اصفهان',
      },
      {
        id: 3,
        name: 'خميني شهر',
      },
      {
        id: 4,
        name: 'خوانسار',
      },
      {
        id: 5,
        name: 'سميرم',
      },
      {
        id: 6,
        name: 'فريدن',
      },
      {
        id: 7,
        name: 'فريدونشهر',
      },
      {
        id: 8,
        name: 'فلاورجان',
      },
      {
        id: 9,
        name: 'شهرضا',
      },
      {
        id: 10,
        name: 'کاشان',
      },
      {
        id: 11,
        name: 'گلپايگان',
      },
      {
        id: 12,
        name: 'لنجان',
      },
      {
        id: 13,
        name: 'نايين',
      },
      {
        id: 14,
        name: 'نجف آباد',
      },
      {
        id: 15,
        name: 'نطنز',
      },
      {
        id: 16,
        name: 'شاهين شهروميمه',
      },
      {
        id: 17,
        name: 'مبارکه',
      },
      {
        id: 18,
        name: 'آران وبيدگل',
      },
      {
        id: 19,
        name: 'تيران وکرون',
      },
      {
        id: 20,
        name: 'چادگان',
      },
      {
        id: 21,
        name: 'دهاقان',
      },
      {
        id: 22,
        name: 'برخوار',
      },
      {
        id: 23,
        name: 'خور و بيابانک',
      },
      {
        id: 24,
        name: 'بو يين و مياندشت',
      },
    ],
  },
  {
    id: 11,
    name: 'سيستان وبلوچستان',
    cities: [
      {
        id: 1,
        name: 'ايرانشهر',
      },
      {
        id: 2,
        name: 'چاه بهار',
      },
      {
        id: 3,
        name: 'خاش',
      },
      {
        id: 4,
        name: 'زابل',
      },
      {
        id: 5,
        name: 'زاهدان',
      },
      {
        id: 6,
        name: 'سراوان',
      },
      {
        id: 7,
        name: 'نيک شهر',
      },
      {
        id: 8,
        name: 'راسک',
      },
      {
        id: 9,
        name: 'کنارک',
      },
      {
        id: 10,
        name: 'زهک',
      },
      {
        id: 11,
        name: 'هيرمند',
      },
      {
        id: 12,
        name: 'دلگان',
      },
      {
        id: 13,
        name: 'مهرستان',
      },
      {
        id: 14,
        name: 'سيب و سوران',
      },
      {
        id: 15,
        name: 'نيمروز',
      },
      {
        id: 16,
        name: 'هامون',
      },
      {
        id: 17,
        name: 'ميرجاوه',
      },
      {
        id: 18,
        name: 'قصرقند',
      },
      {
        id: 19,
        name: 'فنوج',
      },
      {
        id: 20,
        name: 'بمپور',
      },
      {
        id: 21,
        name: 'تفتان',
      },
      {
        id: 22,
        name: 'دشتیاری',
      },
      {
        id: 23,
        name: 'سرباز',
      },
    ],
  },
  {
    id: 12,
    name: 'كردستان',
    cities: [
      {
        id: 1,
        name: 'بانه',
      },
      {
        id: 2,
        name: 'بيجار',
      },
      {
        id: 3,
        name: 'سقز',
      },
      {
        id: 4,
        name: 'سنندج',
      },
      {
        id: 5,
        name: 'قروه',
      },
      {
        id: 6,
        name: 'مريوان',
      },
      {
        id: 7,
        name: 'ديواندره',
      },
      {
        id: 8,
        name: 'كامياران',
      },
      {
        id: 9,
        name: 'سروآباد',
      },
      {
        id: 10,
        name: 'دهگلان',
      },
    ],
  },
  {
    id: 13,
    name: 'همدان',
    cities: [
      {
        id: 1,
        name: 'تويسركان',
      },
      {
        id: 2,
        name: 'ملاير',
      },
      {
        id: 3,
        name: 'نهاوند',
      },
      {
        id: 4,
        name: 'همدان',
      },
      {
        id: 5,
        name: 'كبودرآهنگ',
      },
      {
        id: 6,
        name: 'اسدآباد',
      },
      {
        id: 7,
        name: 'بهار',
      },
      {
        id: 8,
        name: 'رزن',
      },
      {
        id: 9,
        name: 'فامنين',
      },
      {
        id: 10,
        name: 'درگزین',
      },
    ],
  },
  {
    id: 14,
    name: 'چهارمحال وبختياري',
    cities: [
      {
        id: 1,
        name: 'بروجن',
      },
      {
        id: 2,
        name: 'شهرکرد',
      },
      {
        id: 3,
        name: 'فارسان',
      },
      {
        id: 4,
        name: 'لردگان',
      },
      {
        id: 5,
        name: 'اردل',
      },
      {
        id: 6,
        name: 'کوهرنگ',
      },
      {
        id: 7,
        name: 'کيار',
      },
      {
        id: 8,
        name: 'سامان',
      },
      {
        id: 9,
        name: 'بن',
      },
      {
        id: 10,
        name: 'خانميرزا',
      },
    ],
  },
  {
    id: 15,
    name: 'لرستان',
    cities: [
      {
        id: 1,
        name: 'اليگودرز',
      },
      {
        id: 2,
        name: 'بروجرد',
      },
      {
        id: 3,
        name: 'خرم آباد',
      },
      {
        id: 4,
        name: 'دلفان',
      },
      {
        id: 5,
        name: 'دورود',
      },
      {
        id: 6,
        name: 'کوهدشت',
      },
      {
        id: 7,
        name: 'ازنا',
      },
      {
        id: 8,
        name: 'پلدختر',
      },
      {
        id: 9,
        name: 'سلسله',
      },
      {
        id: 10,
        name: 'چگني',
      },
      {
        id: 11,
        name: 'رومشکان',
      },
    ],
  },
  {
    id: 16,
    name: 'ايلام',
    cities: [
      {
        id: 1,
        name: 'ايلام',
      },
      {
        id: 2,
        name: 'دره شهر',
      },
      {
        id: 3,
        name: 'دهلران',
      },
      {
        id: 4,
        name: 'چرداول',
      },
      {
        id: 5,
        name: 'مهران',
      },
      {
        id: 6,
        name: 'آبدانان',
      },
      {
        id: 7,
        name: 'ايوان',
      },
      {
        id: 8,
        name: 'ملكشاهي',
      },
      {
        id: 9,
        name: 'سيروان',
      },
      {
        id: 10,
        name: 'بدره',
      },
      {
        id: 11,
        name: 'هلیلان',
      },
    ],
  },
  {
    id: 17,
    name: 'كهگيلويه وبويراحمد',
    cities: [
      {
        id: 1,
        name: 'بويراحمد',
      },
      {
        id: 2,
        name: 'كهگيلويه',
      },
      {
        id: 3,
        name: 'گچساران',
      },
      {
        id: 4,
        name: 'دنا',
      },
      {
        id: 5,
        name: 'بهمئي',
      },
      {
        id: 6,
        name: 'چرام',
      },
      {
        id: 7,
        name: 'باشت',
      },
      {
        id: 8,
        name: 'لنده',
      },
      {
        id: 9,
        name: 'مارگون',
      },
    ],
  },
  {
    id: 18,
    name: 'بوشهر',
    cities: [
      {
        id: 1,
        name: 'بوشهر',
      },
      {
        id: 2,
        name: 'تنگستان',
      },
      {
        id: 3,
        name: 'دشتستان',
      },
      {
        id: 4,
        name: 'دشتي',
      },
      {
        id: 5,
        name: 'دير',
      },
      {
        id: 6,
        name: 'كنگان',
      },
      {
        id: 7,
        name: 'گناوه',
      },
      {
        id: 8,
        name: 'ديلم',
      },
      {
        id: 9,
        name: 'جم',
      },
      {
        id: 10,
        name: 'عسلويه',
      },
    ],
  },
  {
    id: 19,
    name: 'زنجان',
    cities: [
      {
        id: 1,
        name: 'ابهر',
      },
      {
        id: 3,
        name: 'خدابنده',
      },
      {
        id: 4,
        name: 'زنجان',
      },
      {
        id: 6,
        name: 'ايجرود',
      },
      {
        id: 7,
        name: 'خرمدره',
      },
      {
        id: 8,
        name: 'طارم',
      },
      {
        id: 9,
        name: 'ماهنشان',
      },
      {
        id: 10,
        name: 'سلطانيه',
      },
    ],
  },
  {
    id: 20,
    name: 'سمنان',
    cities: [
      {
        id: 1,
        name: 'دامغان',
      },
      {
        id: 2,
        name: 'سمنان',
      },
      {
        id: 3,
        name: 'شاهرود',
      },
      {
        id: 4,
        name: 'گرمسار',
      },
      {
        id: 5,
        name: 'مهدئ شهر',
      },
      {
        id: 6,
        name: 'آرادان',
      },
      {
        id: 7,
        name: 'ميامي',
      },
      {
        id: 8,
        name: 'سرخه',
      },
    ],
  },
  {
    id: 21,
    name: 'يزد',
    cities: [
      {
        id: 1,
        name: 'اردكان',
      },
      {
        id: 2,
        name: 'بافق',
      },
      {
        id: 3,
        name: 'تفت',
      },
      {
        id: 4,
        name: 'مهريز',
      },
      {
        id: 5,
        name: 'يزد',
      },
      {
        id: 6,
        name: 'ميبد',
      },
      {
        id: 7,
        name: 'ابركوه',
      },
      {
        id: 8,
        name: 'اشکذر',
      },
      {
        id: 9,
        name: 'خاتم',
      },
      {
        id: 11,
        name: 'بهاباد',
      },
    ],
  },
  {
    id: 22,
    name: 'هرمزگان',
    cities: [
      {
        id: 1,
        name: 'ابوموسي',
      },
      {
        id: 2,
        name: 'بندرعباس',
      },
      {
        id: 3,
        name: 'بندرلنگه',
      },
      {
        id: 4,
        name: 'قشم',
      },
      {
        id: 5,
        name: 'ميناب',
      },
      {
        id: 6,
        name: 'جاسك',
      },
      {
        id: 7,
        name: 'رودان',
      },
      {
        id: 8,
        name: 'حاجي اباد',
      },
      {
        id: 9,
        name: 'بستك',
      },
      {
        id: 10,
        name: 'خمير',
      },
      {
        id: 11,
        name: 'پارسيان',
      },
      {
        id: 12,
        name: 'سيريك',
      },
      {
        id: 13,
        name: 'بشاگرد',
      },
    ],
  },
  {
    id: 23,
    name: 'تهران',
    cities: [
      {
        id: 1,
        name: 'تهران',
      },
      {
        id: 2,
        name: 'دماوند',
      },
      {
        id: 3,
        name: 'رئ',
      },
      {
        id: 4,
        name: 'شميرانات',
      },
      {
        id: 6,
        name: 'ورامين',
      },
      {
        id: 9,
        name: 'شهريار',
      },
      {
        id: 10,
        name: 'اسلامشهر',
      },
      {
        id: 12,
        name: 'رباط کريم',
      },
      {
        id: 13,
        name: 'پاكدشت',
      },
      {
        id: 14,
        name: 'فيروزكوه',
      },
      {
        id: 16,
        name: 'قدس',
      },
      {
        id: 17,
        name: 'ملارد',
      },
      {
        id: 18,
        name: 'پيشوا',
      },
      {
        id: 19,
        name: 'بهارستان',
      },
      {
        id: 20,
        name: 'پرديس',
      },
      {
        id: 21,
        name: 'قرچک',
      },
    ],
  },
  {
    id: 24,
    name: 'اردبيل',
    cities: [
      {
        id: 1,
        name: 'اردبيل',
      },
      {
        id: 2,
        name: 'بيله سوار',
      },
      {
        id: 3,
        name: 'خلخال',
      },
      {
        id: 4,
        name: 'مشگين شهر',
      },
      {
        id: 5,
        name: 'گرمي',
      },
      {
        id: 6,
        name: 'پارس آباد',
      },
      {
        id: 7,
        name: 'كوثر',
      },
      {
        id: 8,
        name: 'نمين',
      },
      {
        id: 9,
        name: 'نير',
      },
      {
        id: 10,
        name: 'سرعين',
      },
      {
        id: 11,
        name: 'اصلاندوز',
      },
    ],
  },
  {
    id: 25,
    name: 'قم',
    cities: [
      {
        id: 1,
        name: 'قم',
      },
    ],
  },
  {
    id: 26,
    name: 'قزوين',
    cities: [
      {
        id: 1,
        name: 'بوئين زهرا',
      },
      {
        id: 2,
        name: 'تاكستان',
      },
      {
        id: 3,
        name: 'قزوين',
      },
      {
        id: 4,
        name: 'آبيك',
      },
      {
        id: 5,
        name: 'البرز',
      },
      {
        id: 6,
        name: 'آوج',
      },
    ],
  },
  {
    id: 27,
    name: 'گلستان',
    cities: [
      {
        id: 1,
        name: 'بندرگز',
      },
      {
        id: 2,
        name: 'تركمن',
      },
      {
        id: 3,
        name: 'علي آباد کتول',
      },
      {
        id: 4,
        name: 'كردكوئ',
      },
      {
        id: 5,
        name: 'گرگان',
      },
      {
        id: 6,
        name: 'گنبدكاووس',
      },
      {
        id: 7,
        name: 'مينودشت',
      },
      {
        id: 8,
        name: 'آق قلا',
      },
      {
        id: 9,
        name: 'كلاله',
      },
      {
        id: 10,
        name: 'آزادشهر',
      },
      {
        id: 11,
        name: 'راميان',
      },
      {
        id: 12,
        name: 'مراوه تپه',
      },
      {
        id: 13,
        name: 'گميشان',
      },
      {
        id: 14,
        name: 'گاليكش',
      },
    ],
  },
  {
    id: 28,
    name: 'خراسان شمالي',
    cities: [
      {
        id: 1,
        name: 'اسفراين',
      },
      {
        id: 2,
        name: 'بجنورد',
      },
      {
        id: 3,
        name: 'جاجرم',
      },
      {
        id: 4,
        name: 'شيروان',
      },
      {
        id: 5,
        name: 'فاروج',
      },
      {
        id: 6,
        name: 'مانه وسملقان',
      },
      {
        id: 7,
        name: 'گرمه',
      },
      {
        id: 8,
        name: 'راز و جرگلان',
      },
    ],
  },
  {
    id: 29,
    name: 'خراسان جنوبي',
    cities: [
      {
        id: 1,
        name: 'بيرجند',
      },
      {
        id: 2,
        name: 'درميان',
      },
      {
        id: 3,
        name: 'سربيشه',
      },
      {
        id: 4,
        name: 'قائنات',
      },
      {
        id: 5,
        name: 'نهبندان',
      },
      {
        id: 6,
        name: 'سرايان',
      },
      {
        id: 7,
        name: 'فردوس',
      },
      {
        id: 8,
        name: 'بشرويه',
      },
      {
        id: 9,
        name: 'زيرکوه',
      },
      {
        id: 10,
        name: 'خوسف',
      },
      {
        id: 11,
        name: 'طبس',
      },
    ],
  },
  {
    id: 30,
    name: 'البرز',
    cities: [
      {
        id: 1,
        name: 'کرج',
      },
      {
        id: 2,
        name: 'ساوجبلاغ',
      },
      {
        id: 3,
        name: 'نظرآباد',
      },
      {
        id: 4,
        name: 'طالقان',
      },
      {
        id: 5,
        name: 'اشتهارد',
      },
      {
        id: 6,
        name: 'فرديس',
      },
    ],
  },
]

const roles = [
  {
    roleId: 1,
    name: 'آزمون دهنده',
    key: 'examiner',
    createDate: '2020-12-06T23:42:24.853+03:30',
  },
  {
    roleId: 2,
    name: 'مدیر ارشد',
    key: 'admin',
    createDate: '2020-12-06T23:44:50.31+03:30',
  },
  {
    roleId: 3,
    name: 'مدیر داخلی',
    key: 'manager',
    createDate: '2020-12-06T23:44:50.31+03:30',
  },
  {
    roleId: 4,
    name: 'مدیر مالی',
    key: 'financial',
    createDate: '2020-12-06T23:44:50.31+03:30',
  },
  {
    roleId: 5,
    name: 'مدیر بورسیه',
    key: 'scholarship',
    createDate: '2020-12-06T23:44:50.31+03:30',
  },
  {
    roleId: 6,
    name: 'داور',
    key: 'referee',
    createDate: '2020-12-06T23:44:50.31+03:30',
  },
  {
    roleId: 7,
    name: 'پشتیبانی',
    key: 'support',
    createDate: '2020-12-06T23:44:50.31+03:30',
  },
  {
    roleId: 8,
    name: 'توسعه دهنده',
    key: 'developer',
    createDate: '2020-12-09T16:12:51.833+03:30',
  },
  {
    roleId: 9,
    name: 'افیلیت مارکتینگ',
    key: 'developer',
    createDate: '2020-12-09T16:12:51.833+03:30',
  },
  {
    roleId: 10,
    name: 'مدیر رویداد',
    key: 'eventManager',
    createDate: '2022-12-09T16:12:51.833+03:30',
  },
]

const scholarshipObtainedPosition = {
  1: 'مقام منطقه ای',
  2: 'مقام استانی',
  3: 'مقام کشوری',
  4: 'مقام بین المللی',
}

const scholarshipRequestStatus = {
  100: 'درحال بررسی',
  105: 'رد شده',
  110: 'تایید شده',
}

const userStates = {
  SHOUD_PURCHASE: 1,
  SHOUD_COMPLETE_PROFILE: 2,
  SHOUD_START_EXAM: 3,
  EXAM_IS_COMPLETED: 4,
  EXAM_RESULT_IS_READY: 5,
}

export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    regions: proviences,
    ages: ageCategories,
    roles,
    scholarshipObtainedPosition,
    scholarshipRequestStatus,
    genders,
    countries,
    knowUsTypes,
    educations,
    registrerType,
    timeSpents,
    userStates,
  },
  reducers: {
    regionsFetched: (state, { payload }) => ({ ...state, regions: payload }),
    agesFetched: (state, { payload }) => ({ ...state, ages: payload }),
    rolesFetched: (state, { payload }) => ({ ...state, roles: payload }),
    gendersFetched: (state, { payload }) => ({ ...state, genders: payload }),
    countriesFetched: (state, { payload }) => ({ ...state, countries: payload }),
    knowUsTypesFetched: (state, { payload }) => ({ ...state, knowUsTypes: payload }),
    educationsFetched: (state, { payload }) => ({ ...state, educations: payload }),
    registrerTypeFetched: (state, { payload }) => ({ ...state, registrerType: payload }),
    timeSpentsFetched: (state, { payload }) => ({ ...state, timeSpents: payload }),
  },
})

export default commonSlice.reducer

export const {
  regionsFetched,
  agesFetched,
  gendersFetched,
  countriesFetched,
  knowUsTypesFetched,
  educationsFetched,
  registrerTypeFetched,
  timeSpentsFetched,
} = commonSlice.actions

export const getRegions = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/regions',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(regionsFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getAges = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/agecategories',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(regionsFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getRoles = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/agecategories',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(regionsFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getGenders = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/genders',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(gendersFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getCountries = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/countries',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(countriesFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getKnowUsTypes = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/knowUsTypes',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(knowUsTypesFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getEducations = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/educations',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(educationsFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getRegistrerType = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/registrerType',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(registrerTypeFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getTimeSpents = () => (dispatch) => {
  axios({
    method: 'post',
    url: 'common/timeSpents',
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(timeSpentsFetched(res?.data.data))
    })
    .catch((e) => {
      console.error(e)
    })
}

export const selectorCommon = (state) => state.common
